<template>
  <v-container fluid> <br>

    <ComponenteLoading :is-loading="loading" :message="mensaje_loading" />
    <v-card-title style="font-size: 20px; font-weight: 900; text-transform: uppercase; letter-spacing: 1px;">
      {{ $t('simulacion.tab.curvas') }}
    </v-card-title>
    <v-divider :thickness="3" class=" my-2"></v-divider>
    <v-row justify="end">
      <v-col cols="auto">
        <v-btn
          class="btn-guardar"
          v-if="caso_base === true"
          color="primary"
          @click="guardar_curvas_generales()"
        >
          {{ $t('pestana_configuracion.guardar') }}
        </v-btn>
      </v-col>
    </v-row>
    <br /><br />
    
    <v-row justify="center"> 
      <v-col
        cols="11"
        v-for="(tabla, tablaIndex) in tablas_local"
        :key="tablaIndex"
      >
        <v-card class="pa-4">
          <v-row>
            <v-col cols="5">
              <v-card-title class="text-h6">
                {{ $t(`pestana_configuracion.nombres_curvas.${tabla.nombre}`) }}
              </v-card-title>

              <v-data-table
                :headers="getHeaders(tabla)"
                :items="tabla.filas"
                item-value="id"
                class="elevation-1 mb-2 text-center"
                :items-per-page="-1"
                hide-default-footer
              >
                <template #item="{ item, index: rowIndex }">
                  <tr>
                    <td>
                      <v-text-field
                        v-model="item.unidad"
                        @blur="ordenarFilas(tablaIndex)"
                        density="compact"
                        hide-details
                        :placeholder="tabla.unidad"
                      />
                    </td>
                    <td>
                      <v-text-field
                        :model-value="formatNumber(item.capex)"
                        @update:modelValue="val => updateNumber(item, 'capex', val)"
                        hide-details
                        density="compact"
                      />
                    </td>
                    <td>
                      <v-text-field
                        :model-value="formatNumber(item.opex)"
                        @update:modelValue="val => updateNumber(item, 'opex', val)"
                        density="compact"
                        hide-details
                      />
                    </td>
                    <td>
                      <v-btn
                      :disabled="this.disabled"
                        icon
                        color="red"
                        size="small"
                        @click="eliminarFilaPorIndice(tablaIndex, rowIndex)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <v-btn  :disabled="this.disabled" color="primary" @click="agregarFila(tablaIndex)">
                <v-icon start>mdi-plus</v-icon>
                {{ $t('pestana_configuracion.anadir_fila') }}
              </v-btn>
            </v-col>

            <v-col cols="6">
              <ComponenteGrafica :options="generarDatosGrafica(tabla.filas)" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>



<script>
import ComponenteGrafica from '../components/ComponenteGrafica.vue';
import ComponenteLoading from './ComponenteLoading.vue';
import JSZip from 'jszip';
import axios from 'axios';
import store from '../store';
import { boolean } from 'yup';
export default {
  data() {
    return {
curvasEditables: structuredClone(this.curvasEspecificas),
        loading: false,
        mensaje_loading: "",

        grafica_lineas: {
            title: {
                text: 'Gráfica de Líneas'
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: [
                {
                type: 'value',
                name: 'Serie A',
                position: 'left'
                },
                {
                type: 'value',
                name: 'Serie B',
                position: 'right'
                }
            ],
            series: [
                {
                name: 'Serie A',
                data: [150, 230, 224, 218, 135, 147, 260],
                type: 'line',
                yAxisIndex: 0
                },
                {
                name: 'Serie B',
                data: [320, 332, 301, 334, 390, 330, 320],
                type: 'line',
                yAxisIndex: 1
                }
            ]
            },



      headers: [
        { title: 'Unidad', key: 'unidad' },
        { title: this.$t('pestana_configuracion.capex'), key: 'capex'},
        { title: this.$t('pestana_configuracion.opex'), key: 'opex'},
        { title: '', key: 'actions', sortable: false }
      ],
      nextId: 1,

      tablas_local:[],

      xtablas_local: [
        { nombre: this.$t('pestana_configuracion.electrolizador'), unidad: 'MW', filas: [
            { id: this.nextId++, unidad: '1', capex: '500', opex: '10' },
            { id: this.nextId++, unidad: '2', capex: '950', opex: '20' },
            { id: this.nextId++, unidad: '3', capex: '1400', opex: '35' },
            { id: this.nextId++, unidad: '4', capex: '1800', opex: '50' },
        ]},
        { nombre: 'BOP', unidad: 'MW', filas: [
            { id: this.nextId++, unidad: '1', capex: '200', opex: '5' },
            { id: this.nextId++, unidad: '2', capex: '400', opex: '8' },
            { id: this.nextId++, unidad: '3', capex: '600', opex: '12' },
            { id: this.nextId++, unidad: '4', capex: '800', opex: '15' },
        ]},
        { nombre: this.$t('pestana_configuracion.planta_fv'), unidad: 'MW', filas: [
            { id: this.nextId++, unidad: '1', capex: '300', opex: '3' },
            { id: this.nextId++, unidad: '2', capex: '600', opex: '6' },
            { id: this.nextId++, unidad: '3', capex: '900', opex: '9' },
            { id: this.nextId++, unidad: '4', capex: '1200', opex: '12' },
        ]},
        { nombre: this.$t('pestana_configuracion.planta_eolica'), unidad: 'MW', filas: [
            { id: this.nextId++, unidad: '1', capex: '350', opex: '7' },
            { id: this.nextId++, unidad: '2', capex: '700', opex: '14' },
            { id: this.nextId++, unidad: '3', capex: '1050', opex: '21' },
            { id: this.nextId++, unidad: '4', capex: '1400', opex: '28' },
        ]},
        { nombre: this.$t('pestana_configuracion.bateria'), unidad: 'MWh', filas: [
            { id: this.nextId++, unidad: '0.5', capex: '250', opex: '4' },
            { id: this.nextId++, unidad: '1', capex: '500', opex: '8' },
            { id: this.nextId++, unidad: '1.5', capex: '750', opex: '12' },
            { id: this.nextId++, unidad: '2', capex: '1000', opex: '16' },
        ]},
        { nombre: this.$t('pestana_configuracion.alamcenamiento_hidrogeno'), unidad: 'tonH2', filas: [
            { id: this.nextId++, unidad: '10', capex: '300', opex: '6' },
            { id: this.nextId++, unidad: '20', capex: '600', opex: '12' },
            { id: this.nextId++, unidad: '30', capex: '900', opex: '18' },
            { id: this.nextId++, unidad: '40', capex: '1200', opex: '24' },
        ]},
        { nombre: this.$t('pestana_configuracion.ducto'), unidad: 'km', filas: [
            { id: this.nextId++, unidad: '1', capex: '100', opex: '2' },
            { id: this.nextId++, unidad: '2', capex: '180', opex: '3.5' },
            { id: this.nextId++, unidad: '3', capex: '250', opex: '5' },
            { id: this.nextId++, unidad: '4', capex: '320', opex: '6.5' },
        ]},
        /*{ nombre: this.$t('pestana_configuracion.conexion_electrica'), unidad: 'km', filas: [
            { id: this.nextId++, unidad: '1', capex: '120', opex: '2.5' },
            { id: this.nextId++, unidad: '2', capex: '240', opex: '5' },
            { id: this.nextId++, unidad: '3', capex: '360', opex: '7.5' },
            { id: this.nextId++, unidad: '4', capex: '480', opex: '10' },
        ]},*/
        { nombre: this.$t('pestana_configuracion.tube_trailer'), unidad: 'Número', filas: [
            { id: this.nextId++, unidad: '1', capex: '80', opex: '1.5' },
            { id: this.nextId++, unidad: '2', capex: '160', opex: '3' },
            { id: this.nextId++, unidad: '3', capex: '240', opex: '4.5' },
            { id: this.nextId++, unidad: '4', capex: '320', opex: '6' },
        ]},
        ]
     
    }
  },


  props: {

    curvas: {
      type: Object,
      required: false,
      default: null
    },

    caso_base: {
      type: boolean,
      required: true,
      default: null
    },
    
    disabled:{
      type:Boolean,
      default:false,
    },
    id_simulacion: {
      type: [String, Number],
      default: null
    }

  },

  components: {
    ComponenteGrafica,
    ComponenteLoading,
  },

  methods: {
    async obtener_curvas_simulacion(id_simulacion) {
  this.loading = true;
  this.mensaje_loading = "Cargando curvas de simulación...";

  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/api/descargar-entrada-simulacion/${id_simulacion}/`,
      {
        responseType: "blob",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + store.state.token,
        },
      }
    );

    const zip = await JSZip.loadAsync(response.data);
    const file = Object.keys(zip.files).find(f => f.endsWith("entrada.json"));

    if (file) {
      const content = await zip.file(file).async("string");
      const json = JSON.parse(content);

      if (json.curvas_generales) {
        this.tablas_local = json.curvas_generales;
      } else {
        console.warn("No se encontraron curvas_generales en el JSON");
      }
    } else {
      console.error("entrada.json no encontrada en el ZIP");
    }

  } catch (error) {
    console.error("Error al cargar curvas desde simulación:", error);
  } finally {
    this.loading = false;
  }
},

    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value !== 'number') value = Number(value);

      
      if (Number.isInteger(value)) {
        return value.toString().replace('.', ',');
      } else {
        
        return value.toString().replace('.', ',');
      }
    },

    updateNumber(item, field, val) {
      
      const parsed = Number(val.replace(',', '.'));
      
      item[field] = isNaN(parsed) ? 0 : parsed;
    },
    agregarFila(tablaIndex) {
      const maxId = Math.max(0, ...this.tablas_local.flatMap(t => t.filas.map(f => f.id || 0)));
      this.nextId = maxId + 1;

      this.tablas_local[tablaIndex].filas.push({
        id: this.nextId++,
        unidad: '0',
        capex: '',
        opex: ''
      });

      this.$emit('update:tablas', this.tablas_local);
    },

    ordenarFilas(tablaIndex) {
      this.tablas_local[tablaIndex].filas = [...this.tablas_local[tablaIndex].filas.sort((a, b) => Number(a.unidad) - Number(b.unidad))];
    },
    eliminarFilaPorIndice(tablaIndex, filaIndex) {
      this.tablas_local[tablaIndex].filas.splice(filaIndex, 1);
      this.$emit('update:tablas', this.tablas_local);
    },
    generarDatosGrafica(filas) {
      return {
        title: {
          text: this.$t('pestana_configuracion.capex_opex'),
          left: 'center',
          top: 20 
        },
        grid: {
          left: '10%',
          right: '20%', 
          top: 60,
          bottom: 60
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['CAPEX', 'OPEX'],
          orient: 'horizontal',
          bottom: 0
        },
        xAxis: {
          type: 'value', 
          name: 'Unidad'
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('pestana_configuracion.capex'),
          },
          {
            type: 'value',
            name: this.$t('pestana_configuracion.opex'),
            position: 'right',
            offset: 60
          }
        ],
        series: [
          {
            name: 'CAPEX',
            type: 'line',
            smooth: true,
            data: filas.map(f => [Number(f.unidad), Number(f.capex)]),
            yAxisIndex: 0
          },
          {
            name: 'OPEX',
            type: 'line',
            smooth: true,
            data: filas.map(f => [Number(f.unidad), Number(f.opex)]),
            yAxisIndex: 1
          }
        ]
      };
    },
    getHeaders(tabla) {
      return [
        { title: `${tabla.unidad}`, key: 'unidad', align:'center' },
        { title: this.$t('pestana_configuracion.capex'), key: 'capex', align:'center' },
        { title: this.$t('pestana_configuracion.opex'), key: 'opex', align:'center' },
        { title: '', key: 'actions', sortable: false }
      ];
    },


    async obtener_curvas_generales() {
          
      this.loading = true;
      this.mensaje_loading = "Cargando curvas generales...";

          await axios({
              method: 'get',
              url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-curvas-generales/",
              withCredentials: true,
              headers: {
                  Authorization: "Bearer " + store.state.token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json'
              },
              responseType: 'blob' 
          })
          .then((response) => {
              this.loading = false;

              // Crear un objeto FileReader para leer el blob
              const fileReader = new FileReader();

              fileReader.onload = (event) => {
                  const arrayBuffer = event.target.result;

                  // Usar JSZip para descomprimir el archivo
                  JSZip.loadAsync(arrayBuffer).then((zip) => {
                      // Asumimos que el archivo JSON está en la raíz del ZIP
                      const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

                      if (fileName) {
                          zip.file(fileName).async("string").then((jsonContent) => {
                              
                              //console.log(JSON.stringify(jsonContent))
                              //this.datos = JSON.parse(jsonContent);
                              
                              this.tablas_local = JSON.parse(jsonContent);
                              
                              console.log(this.rows);
                          }).catch((err) => {
                              console.error("Error leyendo el archivo JSON del ZIP:", err);
                          });
                      } else {
                          console.error("No se encontró un archivo JSON en el ZIP.");
                      }
                  }).catch((err) => {
                      console.error("Error descomprimiendo el archivo ZIP:", err);
                  });
              };

              // Leer el blob como ArrayBuffer
              fileReader.readAsArrayBuffer(response.data);
          })
          .catch((error) => {
              this.loading = false;
              console.error("Error al obtener las curvas:", error);
          });
    },



    async guardar_curvas_generales() {

      this.loading = true;
      this.mensaje_loading = "Guardando curvas base...";

      try {
        await axios.post(
          process.env.VUE_APP_API_BASE_URL + "/api/guardar-curvas-generales/",
          this.tablas_local,
          {
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              "Content-Type": "application/json",
            },
            responseType: "json",
          }
        );

        this.obtener_curvas_generales();

      } catch (error) {
        console.error("Error al guardar las curvas generales:", error);
      } finally {
        this.loading = false;
      }
    }






  },
 watch: {
  curvas: {
    handler(nuevasCurvas) {
      // Solo actualiza si realmente cambian
      const nuevas = JSON.stringify(nuevasCurvas);
      const actuales = JSON.stringify(this.tablas_local);
      if (nuevas !== actuales) {
        this.tablas_local = JSON.parse(nuevas);
      }
    },
    immediate: true,
    deep: true
  },

  curvasEspecificas: {
    handler(nuevas) {
      const nuevasClonadas = structuredClone(nuevas);
      const actuales = JSON.stringify(this.curvasEditables);
      if (JSON.stringify(nuevasClonadas) !== actuales) {
        this.curvasEditables = nuevasClonadas;
      }
    },
    deep: true
  },

  curvasEditables: {
    handler(nuevasCurvas) {
      this.$emit('update:curvasEspecificas', nuevasCurvas);
    },
    deep: true
  },

  tablas_local: {
    handler(val) {
      const curvasString = JSON.stringify(this.curvas);
      const valString = JSON.stringify(val);
      if (curvasString !== valString) {
        this.$emit('update:curvas', JSON.parse(valString));
      }
    },
    deep: true
  }
},
  mounted(){    
      if (this.curvas.length > 0) {
    this.tablas_local = JSON.parse(JSON.stringify(this.curvas));
  } else if (this.$props.id_simulacion != null) {
    this.obtener_curvas_simulacion(this.$props.id_simulacion);
  } else {
    this.obtener_curvas_generales();
  }
}

}
</script>

<style scoped>
.btn-guardar{
  margin-right: 70px;
}
</style>